var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-section"},[_c('MeasureConfigOptions',{attrs:{"errors":_vm.errors,"context":_vm.context,"show-future-measure":false},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }